<template>
  <div class="forbidden-state terms-pending-state">
    <div class="empty">
      <div class="empty-icon">
        <fa-icon :icon="['fal', 'file-signature']" size="3x"></fa-icon>
      </div>
      <p class="empty-title h5">Aceite dos termos de uso pendente</p>
      <p class="empty-subtitle">
        O acesso ao sistema é liberado assim que o responsável pela conta aceitar
        os termos de uso.
        <br>
        <template v-if="responsible">
          <span class="text-info">
            Peça para <strong>{{ responsible.name }}</strong>
            <span v-if="responsible.email" class="ml-1">({{ responsible.email }})</span>
            entrar no sistema e aceitar os termos.
          </span>
        </template>
        <span class="text-info" v-else>
          Peça para o usuário master da conta entrar no sistema e aceitar os termos.
        </span>
      </p>
      <p class="terms-pending-support">
        <template v-if="responsible">
          Se <strong>{{ responsible.name }}</strong> não for mais o responsável pela conta,
        </template>
        <template v-else>
          Se você não sabe quem é o responsável pela conta,
        </template>
        fale com o nosso suporte pelo WhatsApp
        <a :href="supportLink" target="_blank" rel="noopener" class="terms-pending-support-link">
          <fa-icon :icon="['fab', 'whatsapp']" />{{ supportPhone }}
        </a>
        que ajudamos a resolver.
      </p>
      <div class="empty-action">
        <a
          :href="supportLink"
          target="_blank"
          rel="noopener"
          class="btn btn-primary btn-icon btn-icon-left"
        >
          <fa-icon :icon="['fab', 'whatsapp']" />
          Falar com o suporte
        </a>
        <router-link to="/logout" class="btn btn-icon btn-icon-left ml-2">
          <fa-icon :icon="['fal', 'sign-out-alt']" />
          Sair
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import { whatsappURL } from '@/helpers/link';

const SUPPORT_PHONE = '(41) 9 9995-0939';

export default {
  name: 'TermsPendingState',
  data() {
    return {
      supportPhone: SUPPORT_PHONE,
    };
  },
  computed: {
    ...mapState({
      user: state => state.auth.user,
    }),
    responsible() {
      return this.user?.terms?.responsible || null;
    },
    supportLink() {
      const clinic = this.user?.branch?.name || 'minha clínica';
      const current = this.responsible?.name
        ? ` O usuário master cadastrado é ${this.responsible.name}.`
        : '';
      return whatsappURL(
        this.supportPhone,
        `Olá! Preciso de ajuda com o aceite dos termos de uso da ${clinic}.${current}`,
      );
    },
  },
};
</script>

<style lang="scss">
@import "@/assets/scss/_variables";

.terms-pending-state {
  margin: $unit-10 auto 0;
  .empty-icon svg {
    color: $primary-color;
  }
  .terms-pending-support {
    color: $gray-color-dark;
    font-size: $font-size-sm;
    margin: $unit-4 auto 0;
    max-width: 26rem;
  }
  .terms-pending-support-link {
    font-weight: 600;
    white-space: nowrap;
    svg {
      margin-right: $unit-1;
    }
  }
}
</style>
